module.exports = __webpack_public_path__ + "static/img/IMG(4).17317771.jpg";